import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "fast-forward-single",
  "use": "fast-forward-single-usage",
  "viewBox": "0 0 5.472 9.859",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 5.472 9.859\" id=\"fast-forward-single\"><path data-name=\"Path 15042\" d=\"M5.298 4.49L1.051.182a.612.612 0 0 0-.87 0 .625.625 0 0 0 0 .879L3.994 4.93.181 8.8a.625.625 0 0 0 0 .879.612.612 0 0 0 .87 0l4.247-4.308a.642.642 0 0 0 0-.881z\" fill=\"#0f2847\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol